import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { WindowService } from '../services';
import { some } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ExternalLinkService {
  constructor(private location: Location, @Inject('environment') private environment) { }

  //localRoot: $location.absUrl().replace($location.path(), '').replace('/#', '/'),
  isOnList(list, url) {
    for (let i = 0; i < list.length; i++) {
      if (url.indexOf(list[i]) !== -1) {
        return true;
      }
    }
    return false;
  }
  isExternal(url) {
    if (typeof url !== 'string') {
      return false;
    }
    if (this.isOnList(this.environment.disclaimerForce, url)) {
      return true;
    }
    if (this.isOnList(this.environment.disclaimerBlacklist, url)) {
      return false;
    }
    if (url.toLowerCase().indexOf('http') === 0 || url.toLowerCase().indexOf('https') === 0) {
      //contains http/https and not on blacklist or forced
      return true;
    }
    if (url.indexOf(WindowService.getLocationHost()) !== -1) {
      return false;
    }
    return false;
  }

  isDocumentLibrary(url) {
    if (typeof url !== 'string' || url.length === 0) {
      return false;
    }
    return some(this.environment.documentLibraryDownload, function (pattern) {
      return url.indexOf(pattern) > -1;
    });
  }
  getDisclaimerContent() {
    console.log('BROKEN FIX!!!!!')
    console.log('BROKEN FIX!!!!!')
    console.log('BROKEN FIX!!!!!')
    console.log('BROKEN FIX!!!!!')
    return this.environment.gemsPrefetch.SITEMAP.disclaimerContent;
  }
}
